import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'white-label-footer-auctionprosrva',
    imports: [],
    templateUrl: './white-label-footer-auctionprosrva.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WhiteLabelFooterAuctionProsRVAComponent {
  public currentYear = new Date().getFullYear();
}
